import axios from 'axios';
import store from 'store';

const state = {
  companies: [],
  paginatedCompanies: {},
  company: {},
  step: 'companies-info',
  savedCoverage: false,
  savedSettings: false,
};

const getters = {
  getCompaniesFiltered: st => query => {
    axios.get(`companies?${query}`).then(res => {
      st.paginatedCompanies = res.data;
    });
  },
};

const mutations = {
  setCompanies: (st, payload) => {
    st.companies = payload;
  },
  setPaginatedCompanies: (st, payload) => {
    st.paginatedCompanies = payload;
  },
  setCompanyStep: (st, payload) => {
    st.step = payload;
  },
  setCompany: (st, payload) => {
    st.company = payload;
  },
  setSavedCoverage: (st, payload) => {
    st.savedCoverage = payload;
  },
  setSavedSettings: (st, payload) => {
    st.savedSettings = payload;
  },
};

const actions = {
  getCompanies: ({ commit }) => {
    return new Promise((resolve, reject) => {
      if (store.get('permissions') && store.get('permissions').indexOf('companies.index') >= 0) {
        axios
          .get(`companies?paginated=false`)
          .then(res => {
            commit('setCompanies', res.data);
            resolve();
          })
          .catch(() => {
            reject();
          });
      }
      resolve();
    });
  },
  getPaginatedCompanies: ({ commit }) => {
    commit('setPaginatedCompanies', {});
    if (store.get('permissions') && store.get('permissions').indexOf('companies.index') >= 0) {
      axios.get(`companies`).then(res => {
        commit('setPaginatedCompanies', res.data);
      });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/companies.js